import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TripData, TripSearchFilter } from "../../models";
import { TripBudgetData, TripEconomicData, TripPaymentQuoteData } from "../../models/trip-economics.model";


export const tripBudgetSearchByTripIdRequest = createAction(
    '[TripBudget] TripBudget search by trip id request', props<{ tripValue: TripData }>());

export const tripBudgetPaymentQuoteSearchSuccess = createAction(
    '[TripBudget] TripBudget payment quote search success', props<{ tripPaymentQuotes: TripPaymentQuoteData[] }>());

export const tripBudgetEconomicsSearchSuccess = createAction(
    '[TripBudget] TripBudget economics search success', props<{ tripEconomics: TripEconomicData[] }>());

export const tripBudgetSearchByTripIdSuccess = createAction(
    '[TripBudget] TripBudget search by trip id success', props<{ searchResult: TripBudgetData }>());

export const tripBudgetSearchByTripIdFail = createAction(
    '[TripBudget] TripBudget search by trip id fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripBudgetSearchDataReset = createAction(
    '[TripBudget] TripBudget search data reset');

export const tripBudgetTripSearchRequest = createAction(
    '[TripBudget] TripBudget trip search request', props<{ searchFilter: TripSearchFilter }>());

export const tripBudgetTripSearchAllRequest = createAction(
    '[TripBudget] TripBudget trip search all request');

export const tripBudgetTripSearchSuccess = createAction(
    '[TripBudget] TripBudget trip search success', props<{ searchResult: TripData[] }>());

export const tripBudgetTripSearchFail = createAction(
    '[TripBudget] TripBudget trip search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());
